import type { QueryClient } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { BroadcastHandoffResult } from "@shared/schemas/handoff-broadcast-input.schemas";
import { BaseApiHooksRepository } from "../../base-api-hooks.repository";
import type { TriggerHandoffBroadcastVariables } from "./handoff-broadcast-admin.types";
import { createHandoffBroadcastApi } from "./handoff-broadcast.api";

export class HandoffBroadcastHooksHttpRepositoryImpl extends BaseApiHooksRepository {
  private readonly api;

  constructor(queryClient: QueryClient, apiClient: AxiosInstance) {
    super(queryClient);
    this.api = createHandoffBroadcastApi(apiClient);
  }

  createHooks() {
    return {
      useTrigger: () =>
        this.mutation<
          BroadcastHandoffResult,
          BroadcastHandoffResult,
          TriggerHandoffBroadcastVariables
        >({
          fn: ({ eventIdPublic, contact, recipientUserIds }) =>
            this.api.trigger(eventIdPublic, contact, recipientUserIds),
          parse: (data) => data,
        }),
    };
  }
}
